<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link href="https://www.facebook.com/jinmataicargo/" class="brand-logo" >
        <!-- <vuexy-logo /> -->
        <b-img
          class="d-none d-sm-block"
          :src="brandLogo"
          fluid
          width="50px"
          height="30px"
        >
        </b-img>
        <h2 class="brand-text text-primary ml-1 mt-1 d-none d-sm-block">
          JINMATAICARGO
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            ลืมรหัสผ่าน? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            หากท่านลืมรหัสผ่าน กรุณาใส่ Email หรือ username ที่เคยลงทะเบียนไว้ ลงในช่องด้านล่าง
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules" #default="{invalid}">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="sendToEmail"
            >
              <b-form-group
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                ทำการกู้รหัสผ่าน
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> เข้าสู่ระบบ
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {header_token, token_api} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import { getBrand, getBranchId } from '@/branding'
import axios from "axios";

export default {
  components: {
    BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      brandLogo: getBrand().logo,
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    async sendToEmail() {
      let response = await axios.post(
        taobaoService_dotnet + 'Jinmatai/forget-password',
        // 'https://localhost:5001/Jinmatai/forget-password',
        {
          "email": this.userEmail,
          "branchId": getBranchId()
        },
        { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }}
      );
      var text = response.data
      var splitText = text.split("กรุณาตรวจสอบ Email ของท่าน");
      var word = splitText[0]
      if ( response.data == 'ไม่พบ Email หรือ Username ในระบบ') {
        this.$bvToast.toast('ไม่พบ Email หรือ Username ในระบบ', {
          title: 'ไม่พบข้อมูล',
          variant: 'danger',
          solid: true,
        })
      } else {
        this.$bvToast.toast(word, {
          title: 'กรุณาตรวจสอบ Email ของท่าน',
          variant: 'success',
          solid: true,
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
